<template>
    <v-select-custom
            v-model="selectedItems"
            :items="filteredItems"
            :style="{'--accentText-color': $vuetify.theme.currentTheme.accentText}"
            class="select-filter"
            dense
            full-width
            hide-details
            label="Filter"
            :multiple="!singleSelect"
            @openMenu="$emit('openMenu', $event)">
        <template v-slot:prepend-item>
            <v-list-item-title>
                <v-text-field class="px-2" label="Search" @input="search" :hide-details="singleSelect"/>
            </v-list-item-title>
            <v-list-item
                    v-if="!singleSelect"
                    ripple
                    @click="toggle">
                <v-list-item-action>
                    <v-icon>{{ icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('selectAll') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>
        <template v-if="likesAllItems" v-slot:selection="{index}">
            <div v-if="index === 0" class="accentText--text mt-1">{{ showAll }}</div>
        </template>
        <!--    <template v-else v-slot:selection="{item, index,parent}" >
              <component :is="parent">
                {{ item.text }} {{ index < selectedItems.length -1 ? ', ': ''}}
              </component>

            </template>-->
    </v-select-custom>
</template>

<script>
export default {
  name: "SelectFilter",
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: [Array, Number],
      required: true,
    },
    showAll: {
      type: String,
      required: true,
    },
    singleSelect: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      selectedItems: this.singleSelect ? this.value : this.items,
      filteredItems: this.items,
    };
  },
  watch: {
    items: {
      handler() {
        this.filteredItems = this.items;
        if (this.singleSelect) {
          this.selectedItems = this.value;
        } else {
          this.selectedItems = this.items.map(item => item.value);
        }
      },
      deep: true,
    },
    selectedItems() {
      this.$emit('input', this.selectedItems);
    },
  },
  computed: {
    likesAllItems() {
      return this.selectedItems.length === this.items.length;
    },
    likesSomeItems() {
      return this.selectedItems.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesAllItems) return 'mdi-close-box';
      if (this.likesSomeItems) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    }
  },
  methods: {
    search(val) {
      if (val) {
        this.filteredItems = this.items.filter(item => item.text.toLowerCase().indexOf(val) !== -1);
      } else {
        this.filteredItems = this.items;
      }

    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.selectedItems = [];
        } else {
          this.selectedItems = this.items.map(item => item.value);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "select-filter";
</style>